import React, {Component} from 'react';
import ComboExposureMax from './combo-exposure-max';
import {calcPercentage} from 'helpers/common-helper';
import FilterLineupsByCorrelationStackCombinations from 'components/molecules/filter-lineups-by-correlation-stack-combinations';

class BaseCorrelationStackedTeams extends Component {
    getNotFoundView() {
        return (
            <table key={-1} className="table">
                <tbody>
                    <tr key="teams-not-found" className="empty">
                        <td colSpan="2">Teams were not found.</td>
                    </tr>
                </tbody>
            </table>
        );
    }

    getUsedCombinationView(params) {
        const {players} = this.props;
        const {group, index, combo} = params;

        const percentage = calcPercentage(group.quantity, combo.getQuantity());
        const className = index % 2 === 0 ? 'even' : '';
        const keyTeamPlayersInfo = [],
            oppTeamPlayersInfo = [];
        combo.getPlayerIds().map((id) => {
            const player = players.getPlayer(id);
            if (group.keyPlayer.team === player.team) {
                keyTeamPlayersInfo.push(`${player.positionName} ${player.name}`);
            } else {
                oppTeamPlayersInfo.push(`OPP ${player.positionName} ${player.name}`);
            }
        });

        return (
            <tr key={`combo-${index}`} className={className}>
                <td>
                    <FilterLineupsByCorrelationStackCombinations combo={combo} />
                </td>
                <td>
                    <strong>{keyTeamPlayersInfo.join(' + ')}</strong>
                    {!isEmpty(oppTeamPlayersInfo) ? <strong>{` +  ${oppTeamPlayersInfo.join(' + ')}`}</strong> : null}
                </td>
                <td className="td-stack-per text-blue">{`${percentage}%`}</td>
                {!group.isUniversalStack ? (
                    <td className="td-stack-exp">
                        <div className="percent-in">
                            <ComboExposureMax
                                className={'form-control small-table-input'}
                                stackItemId={group.id}
                                combo={combo.getPlayerIds()}
                            />
                            <span className="percent">%</span>
                        </div>
                    </td>
                ) : null}
            </tr>
        );
    }

    getGroupOfUsedCombinationsView(params) {
        const {rawLineups} = this.props;
        const {group, index} = params;

        const combinationViews = [];
        group.sortedCombos.map((combo, index) => {
            combinationViews.push(this.getUsedCombinationView({group, index, combo}));
        });

        const percentage = calcPercentage(rawLineups.getQuantity(), group.quantity);

        return (
            <table key={`used-${index}`} className="table">
                <thead>
                    {group.isUniversalStack ? (
                        <tr className="hidden-heading">
                            <th className="td-icon"></th>
                            <th>{`QB ${group.keyPlayer.name} Universal Stack`}</th>
                            <th>{`${percentage}%`}</th>
                        </tr>
                    ) : (
                        <tr className="hidden-heading">
                            <th className="td-icon"></th>
                            <th>{`QB ${group.keyPlayer.name} ${group.isGameStack ? 'Game Stack' : 'Team Stack'}`}</th>
                            <th className="td-stack-per">{`${percentage}%`}</th>
                            <th className="td-stack-exp">
                                Exp.
                                <br />
                                max
                            </th>
                        </tr>
                    )}
                </thead>
                <tbody>{combinationViews}</tbody>
            </table>
        );
    }

    getUnusedCombinationView(params) {
        const {players} = this.props;
        const {group, index, combo} = params;

        const percentage = calcPercentage(group.quantity, combo.getQuantity());
        const className = index % 2 === 0 ? 'even' : '';
        const teamPlayersInfo = [];
        combo.getPlayerIds().map((id) => {
            const player = players.getPlayer(id);
            teamPlayersInfo.push(`${player.positionName} ${player.name}`);
        });

        return (
            <tr key={`combo-${index}`} className={className}>
                <td>
                    <FilterLineupsByCorrelationStackCombinations combo={combo} />
                </td>
                <td>
                    <strong>{teamPlayersInfo.join(' + ')}</strong>
                </td>
                <td className="td-stack-per text-blue">{`${percentage}%`}</td>
                <td className="td-stack-exp">
                    <div className="percent-in">
                        <ComboExposureMax
                            className={'form-control small-table-input'}
                            stackItemId={group.id}
                            combo={combo.getPlayerIds()}
                        />
                        <span className="percent">%</span>
                    </div>
                </td>
            </tr>
        );
    }

    getGroupOfUnusedCombinationsView(params) {
        const {group, index} = params;
        const combinationViews = [];

        group.sortedCombos.map((combo, index) => {
            combinationViews.push(this.getUnusedCombinationView({group, index, combo}));
        });

        return (
            <table key={`unused-${index}`} className="table">
                <tbody>{combinationViews}</tbody>
            </table>
        );
    }

    getView(params) {
        const {content} = params;

        return (
            <div className="players-used-table">
                <div className="table-scroll-static">{content}</div>
            </div>
        );
    }
}

export {BaseCorrelationStackedTeams};
